import clickMp3 from './click.mp3';
const CLICK_SFX_PATH = clickMp3;

let audio = null;

function playClick() {
    if (!CLICK_SFX_PATH) return;
    if (!audio) {
        audio = new Audio(CLICK_SFX_PATH);
        audio.volume = 0.35;
    }
    audio.currentTime = 0;
    audio.play().catch(() => {});
}

export function initClickSound() {
    document.addEventListener('pointerdown', (e) => {
        const el = e.target.closest('button, a, [role="button"]');
        if (el && !el.disabled) playClick();
    }, { passive: true });
}
